export interface LoginResponse {
  JWT: string;
  ClientAccessId: string;
  ResponseMessages: string[];
}
